module.exports = __webpack_public_path__ + "img/box-zsd.2862c3c2.svg";